/* Initial number of rows to load for a table */
export const INITIAL_LOAD_ROW_COUNT = 25;

/* Number of additional rows to load when scrolling down in table */
export const LOAD_MORE_ROW_COUNT = 50;

/* The max number of rows we show initially from cache on table switch */
export const MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD = 25;
